import { useT } from "./useLocale";
import type { MessageKey } from "./dictionaries";

/**
 * Renders one interface string in the reader's language.
 * Used as a plain text node so it works anywhere inside JSX.
 */
export const T = ({ k }: { k: MessageKey }) => {
  const t = useT();
  return <>{t(k)}</>;
};

export default T;
